'use client';
import {
  FavoritesCardsMobile,
  FavoritesFiltersMobile,
  FavoritesHeaderMobile,
} from '@widgets/mobile/favorites';
import cn from 'clsx';

import styles from './content.module.scss';

export const FavoritesMobileContent = () => {
  const firstSectionClasses = cn(styles.section, styles['first-section']);

  return (
    <div className={firstSectionClasses}>
      <FavoritesHeaderMobile />

      <FavoritesFiltersMobile />
      <FavoritesCardsMobile />
    </div>
  );
};
